<template>
  <section v-on:click="bubbleOpen = false" v-on:touchstart="bubbleOpen = false">
    <div class="theGame" v-if="openGane">
      <iframe :src="`https://game.cmsriver.com/${gameUri}/`"></iframe>
    </div>
    <div class="gameOver" v-if="gameOver">
      <div class="leaderboard" v-if="leaderboard"
        :style="{width: `${tfSize.w}px`, height: `${tfSize.h}px`}">
        <h5>Leaderboard</h5>
        <h4>Menangkap Kolagen</h4>
        <div class="lbCnt" v-if="loadingLb">
          <div class="lbItem loading"></div>
        </div>
        <div class="lbCnt" v-else>
          <div class="lbItem" v-for="(l, i) in lb" :key="i">
            <div class="pos">{{i + 1}}</div>
            <div class="name">{{l.name}}</div>
            <div class="score">{{l.score}}</div>
          </div>
        </div>
        <div class="lbAction">
          <div class="btn orange back" v-on:click="leaderboard = false"></div>
          <div class="btn orange rounded retry" v-on:click="startGame">
            <img src="../assets/share/reload.svg">
            Main Lagi
          </div>
        </div>
      </div>
      <div class="theGameOver" v-else
        :style="{width: `${tfSize.w}px`, height: `${tfSize.h}px`}">
        <div class="backBtn" v-on:click="goBack"></div>
        <div class="titleImg"></div>
        <div class="gItem">
          <span>Nama</span>
          <div class="gVal name">{{name}}</div>
        </div>
        <div class="gItem">
          <span>Score</span>
          <div class="gVal">{{gameScore.toLocaleString('id')}}</div>
        </div>
        <div class="gItem">
          <span>High Score</span>
          <div class="gVal loading" v-if="loadingHiScore"></div>
          <div class="gVal" v-else>
            {{gameHiScore.toLocaleString('id')}}</div>
        </div>
        <div class="btnCnt">
          <div class="btn orange almost save" :class="{loading: generatingDownload}"
            v-on:click="download"></div>
          <div class="btn orange almost share" v-on:click="share"></div>
        </div>
        <div class="btn orange almost checkLb" v-on:click="openLb">
          <img src="../assets/share/ranking-cup.svg"> Cek Leaderboard</div>
        <div class="btn orange retry" v-on:click="startGame">
          <img src="../assets/share/reload.svg">
          Main Lagi</div>
      </div>
    </div>
    <div class="gameTrueFalse" v-if="openTrueFalse">
      <div :class="{theGame2: true, showAnswer: showAnswer}" ref="trueFalse"
        :style="{width: `${tfSize.w}px`, height: `${tfSize.h}px`}">
        <div class="timerCnt">
          <div class="timerBg">
            <div class="theTimer" :style="{width: `${topScore / 20 * 100}%`}"></div>
          </div>
          <div class="clockIcon"></div>
        </div>
        <div :class="{answer: true, isTrue: theAnswer}"></div>
        <div class="scoreCnt">
          <span>Score</span><div class="theScore">{{score}}</div>
        </div>
        <div class="question">
          <h5>{{sti + 1}}/10</h5>
          <h4>Pernyataan</h4>
          <p>{{st[sti].st}}</p>
        </div>
        <div class="btnCnt">
          <div class="btnFalse" v-on:click="answer(false)"></div>
          <div class="btnTrue" v-on:click="answer(true)"></div>
        </div>
      </div>
    </div>
    <Main ref="main"/>
    <GameShare ref="gameShare"/>
  </section>
</template>

<script>
import Main from '@/components/Main.vue';
import GameShare from '@/components/GameShare.vue';

export default {
  name: 'home',
  components: { Main, GameShare },
  data() {
    return {
      y: '',
      name: '',
      openGane: false,
      game: '',
      gameUri: '',
      tfSize: { w: 0, h: 0 },
      topScore: 0,
      score: 0,
      openTrueFalse: false,
      showAnswer: false,
      theAnswer: false,
      stInterval: null,
      sti: 0,
      st: [],
      gameOver: false,
      leaderboard: false,
      loadingHiScore: true,
      gameScore: 0,
      gameHiScore: 0,
      loadingLb: true,
      lb: [],
      okSound: null,
      errorSound: null,
      generatingDownload: false,
    };
  },
  methods: {
    doNothing() {},
    goBack() {
      this.$router.push(`/fun-and-learn/game/${this.game}`);
    },
    share() {
      this.$refs.gameShare.open({
        game: this.game,
        score: this.gameScore,
      });
    },
    download() {
      this.generatingDownload = true;
      this.$http.post(this.$config.uri('user/score/download'), {
        game: this.game,
      }).then((r) => {
        this.generatingDownload = false;
        const link = document.createElement('a');
        link.setAttribute('download', '');
        link.setAttribute('target', '_blank');
        link.href = r.data.image;
        document.body.appendChild(link);
        link.click();
        link.remove();
      });
    },
    startGame() {
      this.gameOver = false;
      this.leaderboard = false;
      this.openGane = false;
      this.openTrueFalse = false;
      if (this.game === 'true-or-false') {
        const st = [
          {
            st: 'Kolagen yang dibutuhkan tubuh bisa kita dapat dari makanan saja.',
            an: false,
          },
          {
            st: 'Di dalam tulang, kulit, pembuluh darah terdapat kolagen.',
            an: true,
          },
          {
            st: 'Sinar ultraviolet baik untuk pembentukan kolagen.',
            an: false,
          },
          {
            st: 'Keunggulan dari kolagen dengan rantai oligopeptide adalah lebih mudah diserap.',
            an: true,
          },
          {
            st: `Chrysantemum pada Nutrilite Mixed Collagen Drink memberikan manfaat
            protect terhadap ultraviolet dari dalam tubuh.`,
            an: true,
          },
          {
            st: `Dual peptide pada Nutrilite Mixed Collagen Drink adalah kombinasi
            dari Ikan Salmon dan Non-GMO Soy.`,
            an: false,
          },
          {
            st: `Teknologi mutakhir yang digunakan untuk mengkombinasikan dual
            peptide adalah Bio Enzymatic Hidrolysis.`,
            an: true,
          },
          {
            st: 'Kolagen bagi kulit bermanfaat untuk menjaga kekencangan kulit.',
            an: true,
          },
          {
            st: `Salah satu makanan yang dapat mendukung pembentukan kolagen
            adalah makanan tinggi gula.`,
            an: false,
          },
          {
            st: 'Selain kulit, kolagen juga baik untuk sendi dan pencernaan.',
            an: true,
          },
        ];
        this.st = this.shuffle(st);

        this.score = 0;
        this.sti = 0;
        this.topScore = 20;
        this.openTrueFalse = true;
        clearInterval(this.stInterval);
        this.stInterval = setInterval(() => {
          this.topScore -= 1;
          if (this.topScore < 1) {
            this.answer(!this.st[this.sti].an);
          }
        }, 1000);
      } else {
        setTimeout(() => {
          this.openGane = true;
        }, 200);
      }
    },
    openLb() {
      this.loadingLb = true;
      this.leaderboard = true;
      this.$http.get(this.$config.uri(`user/score/${this.game}`)).then((r) => {
        this.loadingLb = false;
        this.lb = (r.data.status === 200) ? r.data.data : [];
      });
    },
    onResized() {
      const s = {
        w: window.innerWidth,
        h: window.innerHeight,
      };
      const r = s.w / s.h;
      if (r >= (720 / 1280)) {
        this.tfSize.w = s.h * (720 / 1280);
        this.tfSize.h = s.h;
      } else {
        this.tfSize.w = s.w;
        this.tfSize.h = s.w * (1280 / 720);
      }
    },
    shuffle(array) {
      let currentIndex = array.length;
      let randomIndex;
      const newArray = array;
      while (currentIndex !== 0) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;
        [newArray[currentIndex], newArray[randomIndex]] = [
          newArray[randomIndex], newArray[currentIndex]];
      }
      return newArray;
    },
    answer(an) {
      clearInterval(this.stInterval);
      this.showAnswer = true;
      if (an === this.st[this.sti].an) {
        this.score += Math.floor(10 + this.topScore / 2);
        this.theAnswer = true;
        this.okSound.play();
      } else {
        this.theAnswer = false;
        this.errorSound.play();
      }
      setTimeout(() => {
        this.showAnswer = false;
        if ((this.sti + 1) === this.st.length) {
          this.leaderboard = false;
          this.gameOver = true;
          this.gameScore = this.score;
          this.loadingHiScore = true;
          this.$http.post(this.$config.uri('user/score'), {
            game: this.game,
            score: this.gameScore,
          }).then((r) => {
            this.loadingHiScore = false;
            this.gameHiScore = (r.data.status === 200) ? r.data.score : 0;
          });
          return;
        }
        this.sti += 1;
        this.topScore = 20;
        this.stInterval = setInterval(() => {
          this.topScore -= 1;
          if (this.topScore < 1) {
            this.answer(!this.st[this.sti].an);
          }
        }, 1000);
      }, 1000);
    },
  },
  created() {
    window.addEventListener('resize', this.onResized);
  },
  destroyed() {
    window.removeEventListener('resize', this.onResized);
  },
  mounted() {
    const d = new Date();
    this.y = d.getFullYear();
    this.game = this.$route.params.game;
    if (this.game === 'memory') this.gameUri = 'm3';
    else if (this.game === 'catch') this.gameUri = 'c3';
    this.name = localStorage.getItem('name');
    const token = localStorage.getItem('token');
    if (!token) {
      this.$refs.main.open((name) => {
        this.name = name;
      });
    }
    this.onResized();
    window.addEventListener('message', (e) => {
      if (!e.data) return;
      if (e.data.action === 'game_over') {
        // Display score and download
        this.openGane = false;
        this.leaderboard = false;
        this.gameOver = true;
        this.gameScore = e.data.score;
        this.loadingHiScore = true;
        this.$http.post(this.$config.uri('user/score'), {
          game: this.game,
          score: e.data.score,
        }).then((r) => {
          this.loadingHiScore = false;
          this.gameHiScore = (r.data.status === 200) ? r.data.score : 0;
        });
      } else if (e.data.action === 'game_close') {
        this.$router.push(`/fun-and-learn/game/${this.game}`);
      }
    });
    this.okSound = new Audio('https://storage.googleapis.com/deepdivedjkt/clg/sounds/ok-sound.webm');
    this.errorSound = new Audio('https://storage.googleapis.com/deepdivedjkt/clg/sounds/error-sound.webm');
    if (!this.name) {
      this.$refs.main.open((name) => {
        this.name = name;
        this.startGame();
      });
    } else {
      this.startGame();
    }
  },
};
</script>

<style scoped lang="scss">
section{
  background-color: #ffc9ca;
  background-image: linear-gradient(#ffc9ca, #fdbbce);
  position: fixed;
  left: 0; top: 0; right: 0; bottom: 0;
  @media (max-width: 680px) {
    position: static;
  }
}
.gameOver{
  position: fixed;
  left: 0; right: 0; top: 0; bottom: 0;
  background-image: url(../assets/game-bg.jpg);
  background-size: cover;
  background-position: center;
  z-index: 92;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  .leaderboard{
    background-image: url(../assets/lb-bg.png);
    background-size: cover;
    background-position: center;
    padding: 40px;
    box-sizing: border-box;
    overflow-y: auto;
    @media (max-width: 680px) {
      padding: 30px;
    }
    @media (max-height: 799px) {
      padding: 30px;
    }
    h5{
      margin: 0;
      font-size: 30px;
      font-weight: normal;
    }
    h4{
      margin: 0 0 20px;
      font-size: 30px;
      font-weight: bold;
    }
    .lbCnt{
      margin: 0 -40px;
      padding: 0 40px;
      @media (max-width: 680px) {
        margin: 0 -30px;
        padding: 0 30px;
      }
      @media (max-height: 799px) {
        margin: 0 -30px;
        padding: 0 30px;
      }
      .lbItem{
        background-color: #ffeeee;
        position: relative;
        padding: 12px 100px 12px 60px;
        margin-bottom: 16px;
        box-shadow: 0 4px 6px rgba(0,0,0,.2);
        border-radius: 50px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        box-sizing: border-box;
        font-size: 22px;
        @media (max-height: 899px) {
          margin-bottom: 8px;
          font-size: 20px;
        }
        @media (max-width: 680px) {
          margin-left: -10px;
          margin-right: -10px;
          font-size: 18px;
          padding-top: 8px; padding-bottom: 8px;
          padding-left: 46px;
          margin-bottom: 6px;
        }
        @media (max-height: 799px) {
          margin-left: -10px;
          margin-right: -10px;
          font-size: 18px;
          padding-top: 8px; padding-bottom: 8px;
          padding-left: 46px;
          margin-bottom: 6px;
        }
        &.loading{
          background-image: url(../assets/loading.svg);
          height: 400px;
          background-position: center;
          background-repeat: no-repeat;
          background-size: 46px auto;
          border-radius: 15px;
          box-shadow: none;
        }
        .name{
          font-weight: normal;
        }
        .pos{
          position: absolute;
          left: 7px; top: 7px;
          background-color: #f5acb8;
          width: 36px; height: 36px;
          border-radius: 50%;
          color: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          @media (max-height: 899px) {
            top: 6px;
            width: 34px; height: 34px;
          }
          @media (max-width: 680px) {
            width: 26px; height: 26px;
          }
          @media (max-height: 799px) {
            width: 26px; height: 26px;
          }
        }
        .score{
          position: absolute;
          right: 20px; top: 0; bottom: 0;
          line-height: 50px;
          @media (max-width: 680px) {
            line-height: 38px;
          }
          @media (max-height: 799px) {
            line-height: 38px;
          }
        }
      }
    }
    .lbAction{
      display: flex;
      padding-top: 20px;
      .btn.back{
        width: 86px; height: 50px;
        box-sizing: border-box;
        background-color: #fff5cb;
        border-radius: 50px;
        background-image: url(../assets/share/arrow.svg);
        background-size: 26px auto;
        background-position: center;
        background-repeat: no-repeat;
        @media (max-width: 680px) {
          background-size: 24px;
          height: 44px;
        }
        @media (max-height: 799px) {
          background-size: 24px;
          height: 44px;
        }
      }
      .btn.retry{
        padding: 0;
        height: 50px;
        line-height: 50px;
        width: calc(100% - 114px);
        margin-left: auto;
        text-align: center;
        font-size: 20px;
        padding-top: 2px;
        box-sizing: border-box;
        @media (max-width: 680px) {
          font-size: 17px;
          height: 44px;
          line-height: 44px;
        }
        @media (max-height: 799px) {
          font-size: 17px;
          height: 44px;
          line-height: 44px;
        }
        img{
          height: 30px;
          vertical-align: middle;
          margin-right: 8px;
        }
      }
    }
  }
  .theGameOver{
    background-image: url(../assets/lb-bg.png);
    background-size: cover;
    background-position: center;
    padding: 40px;
    box-sizing: border-box;
    position: relative;
    overflow: auto;
    @media (max-width: 680px) {
      padding: 30px;
    }
    @media (max-height: 799px) {
      padding: 30px;
    }
    .backBtn{
      position: absolute;
      width: 50px;
      box-sizing: border-box;
      padding: 0;
      left: 20px; top: 14px;
      &:before{
        left: 14px; top: 15px;
      }
    }
    .titleImg{
      height: 140px;
      margin: 40px 0;
      background-image: url(../assets/game-over.png);
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      @media (max-height: 899px) {
        height: 100px;
        margin: 20px 0 30px;
      }
      @media (max-width: 680px) {
        height: 94px;
      }
      @media (max-height: 799px) {
        height: 94px;
      }
    }
    .gItem{
      font-size: 24px;
      text-align: center;
      margin-bottom: 40px;
      @media (max-height: 899px) {
        margin-bottom: 30px;
      }
      @media (max-width: 680px) {
        font-size: 18px;
        margin-bottom: 20px;
      }
      @media (max-height: 799px) {
        font-size: 18px;
        margin-bottom: 20px;
      }
      span{
        font-family: CarlaSansBold;
        margin-bottom: 10px;
        display: block;
      }
      .gVal{
        font-weight: normal;
        background-color: #ffeeee;
        width: 140px;
        padding: 10px 0;
        margin: 0 auto;
        border-radius: 50px;
        box-shadow: 0 4px 6px rgba(0,0,0,.2);
        white-space: nowrap;
        overflow: hidden;
        box-sizing: border-box;
        text-overflow: ellipsis;
        @media (max-width: 680px) {
          padding: 6px 0;
          width: 96px;
        }
        @media (max-height: 799px) {
          padding: 6px 0;
          width: 96px;
        }
        &.loading{
          height: 48px;
          background-image: url(../assets/loading.svg);
          background-size: 30px auto;
          background-position: center;
          background-repeat: no-repeat;
          @media (max-width: 680px) {
            height: 34px;
            background-size: 20px auto;
          }
          @media (max-height: 799px) {
            height: 34px;
            background-size: 20px auto;
          }
        }
        &.name{
          width: 360px;
          @media (max-width: 680px) {
            width: 260px;
          }
          @media (max-height: 799px) {
            width: 260px;
          }
        }
      }
    }
    .btn.almost{
      background-color: #fff5cb;
    }
    .btnCnt{
      padding-top: 20px;
      display: flex;
      justify-content: center;
      margin-bottom: 20px;
      .btn{
        width: 50px; height: 50px;
        margin: 0 10px;
        border-radius: 50%;
        background-size: 26px auto;
        background-position: center;
        background-repeat: no-repeat;
        @media (max-width: 680px) {
          background-size: 24px auto;
        }
        @media (max-height: 799px) {
          background-size: 24px auto;
        }
        &.share{
          background-image: url(../assets/share/share.svg);
        }
        &.save{
          background-image: url(../assets/share/download.svg);
        }
        &.loading{
          background-image: url(../assets/loading.svg);
          background-size: 30px auto;
        }
      }
    }
    .btn.checkLb, .btn.retry{
      display: block;
      padding: 0;
      width: 340px; height: 50px;
      border-radius: 50px;
      text-align: center;
      line-height: 50px;
      font-size: 20px;
      padding-top: 2px;
      margin: 0 auto 20px;
      @media (max-width: 680px) {
        width: 280px;
        line-height: 44px;
        height: 44px;
        font-size: 17px;
      }
      @media (max-height: 799px) {
        width: 280px;
        line-height: 44px;
        height: 44px;
        font-size: 17px;
      }
      img{
        height: 30px;
        vertical-align: middle;
        margin-right: 8px;
        @media (max-width: 680px) {
          height: 24px;
        }
        @media (max-height: 799px) {
          height: 24px;
        }
      }
    }
    .btn.retry{
      width: 240px;
      margin-bottom: 0;
      @media (max-width: 680px) {
        width: 200px;
      }
      @media (max-height: 799px) {
        width: 200px;
      }
    }
  }
}
.gameTrueFalse{
  position: fixed;
  left: 0; right: 0; top: 0; bottom: 0;
  background-image: url(../assets/game-bg.jpg);
  background-size: cover;
  background-position: center;
  z-index: 91;
  display: flex;
  justify-content: center;
  align-items: center;
  .theGame2{
    background-image: url(../assets/game-bg.png);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
    .timerCnt{
      position: absolute;
      left: 20px; top: 40px; right: 20px;
      .timerBg{
        position: absolute;
        left: 0; top: 0;
        width: 50%; height: 30px;
        background-image: url(../assets/timebarbg-sheet0.png);
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
      }
      .theTimer{
        position: absolute;
        left: 0; top: 4px;
        width: 100%; height: 24px;
        background-image: url(../assets/timebar-sheet0.png);
        background-size: auto 100%;
        background-position: right center;
        background-repeat: no-repeat;
        transition: width 1s linear;
      }
      .clockIcon{
        width: 46px; height: 46px;
        position: absolute;
        left: -4px; top: -8px;
        background-image: url(../assets/watchicon-sheet0.png);
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
      }
    }
    .answer{
      position: absolute;
      left: 40px; right: 40px; height: 360px;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      top: 50%; margin-top: -180px;
      background-image: url(../assets/false.png);
      opacity: 0; transform: scale(.4);
      transition: transform .4s ease;
      &.isTrue{
        background-image: url(../assets/true.png);
      }
    }
    .scoreCnt{
      font-size: 20px;
      color: #fff;
      text-transform: uppercase;
      font-weight: normal;
      font-family: CarlaSansBold;
      position: absolute;
      right: 20px; top: 40px;
      padding-right: 114px;
      padding-top: 5px;
      @media (max-height: 680px) {
        span{
          display: none;
        }
      }
      .theScore{
        color: #ff8592;
        background-color: #fff;
        font-weight: bold;
        font-family: Arial;
        width: 100px;
        text-align: center;
        position: absolute;
        padding: 4px 0;
        border-radius: 50px;
        right: 0; top: 0;
      }
    }
    .question{
      position: absolute;
      left: 80px; right: 80px;
      top: 50%; transform: translateY(-50%);
      text-align: center;
      margin-top: -40px;
      z-index: 9;
      @media (max-height: 680px) {
        left: 20px; right: 20px;
      }
      h5{
        margin: 0 0 40px;
        background-color: #ffe0dd;
        display: inline-block;
        padding: 4px 14px;
        border-radius: 50px;
        font-size: 30px;
        @media (max-height: 680px) {
          margin-bottom: 30px;
        }
      }
      h4{
        margin: 0 0 30px;
        font-family: CarlaSansBold;
        font-size: 30px;
        @media (max-height: 680px) {
          margin-bottom: 20px;
        }
      }
      p{
        margin: 0;
        line-height: 1.3;
        font-size: 20px;
        @media (max-height: 680px) {
          font-size: 17px;
        }
      }
    }
    .btnCnt{
      position: absolute;
      bottom: 60px;
      left: 26px; right: 26px;
      z-index: 9;
      .btnTrue, .btnFalse{
        width: 50%; bottom: 0; height: 200px;
        position: absolute;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        cursor: pointer;
      }
      .btnTrue{
        background-image: url(../assets/true.png);
        right: 0;
      }
      .btnFalse{
        background-image: url(../assets/false.png);
        left: 0;
      }
    }
    &.showAnswer{
      .question, .btnCnt, .timerCnt{
        display: none;
      }
      .answer{
        opacity: 1;
        transform: none;
      }
    }
  }
}
.theGame{
  position: fixed;
  left: 0; right: 0; top: 0; bottom: 0;
  z-index: 91;
  iframe{
    border: none;
    position: absolute;
    left: 0; top: 0;
    width: 100%; height: 100%;
  }
}
</style>
